import { lazy } from 'react'




// import navigation from '../menu-items'
import Loadable from 'components/Loadable'
import MainLayout from 'layout/main-layout'
import routesTypes from './routes.types'

const HomePage = Loadable(
  lazy(() => import('../views/Home')),
)

const DevotionPage = Loadable(
  lazy(() => import('../views/Devotion')),
)

const DonationPage = Loadable(
  lazy(() => import('../views/Donation')),
)





const routes = [
  // {
  //   path: '/',
  //   element: <HomePage />,
  // },
  // {
  //   path: '/devocao',
  //   element: <DevotionPage />,
  // },
  {
    path: '/',
    element: <DonationPage />,
  },
  
]

const AppRoutes = {
  path: '/',
  element: <MainLayout routes={routesTypes} />,
  children: routes
}

export default AppRoutes
